import type { IHttpConfig } from '../httpClient.model';

function encodeParameter(paramKey: string, paramValue: any): string[] {
  if (paramValue === undefined) {
    return [];
  }
  if (Array.isArray(paramValue)) {
    return paramValue.flatMap(v => encodeParameter(paramKey, v));
  }
  const encoded = `${paramKey}=${encodeURI(paramValue)}`;
  return [encoded];
}

export default (config: IHttpConfig): IHttpConfig => {
  const params = config.params;
  if (!params) {
    return config;
  }

  const queryParams = Object.entries(params)
    .flatMap(([key, val]) => encodeParameter(key, val))
    .join('&');

  const updatedConfig = {
    ...config,
    url: queryParams.length ? `${config.url}?${queryParams}` : config.url,
  };

  return updatedConfig;
};
